import React from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, InputNumber, Row, Select, Switch } from "antd";
import MaskedInput from "react-text-mask";

import { DatePickerWithMask, UIFormSection, UILabelHelp, UISwitchField, UIUpload } from "../../../components";

const GeneralInfoFields = ({
	tipo_pessoa,
	onTipoPessoaChange,
	settings,
	displayParamsREPP,
	displayAppCompany,
	displayAppEmployee,
	nomeInputRef,
	uploadRef,
	onCnpjPrincipalChange,
	onDataNascimentoKeyUp,
}) => (
	<UIFormSection
		icon={<i className="fal fa-clipboard-list" />}
		title="Informações gerais"
		description="Dados principais da empresa."
	>
		<Row gutter={16}>
			<Col xs={24} sm={5}>
				<UIUpload
					name="avatar"
					ref={uploadRef}
					label="Logo"
					labelError="Logo"
					acceptedFiles={['jpg', 'jpeg', 'png']}
					maxFileSize={4}
				/>
			</Col>
			<Col xs={24} sm={5}>
				<Form.Item
					name="cnpj_principal"
					label={<>Empresa principal <UILabelHelp content="Define esta empresa como a principal do grupo." /></>}
					valuePropName="checked"
				>
					<Switch onChange={onCnpjPrincipalChange} />
				</Form.Item>
			</Col>
			<Col xs={24} sm={14}>
				<Form.Item name="nome" label="Nome" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
					<Input ref={nomeInputRef} placeholder="Digite o nome da empresa" />
				</Form.Item>
			</Col>
		</Row>
		<Row gutter={16}>
			<Col xs={24} sm={12}>
				<Form.Item name="tipo_pessoa" label="Tipo de Pessoa" rules={[{ required: true, message: "Campo obrigatório." }]}>
					<Select
						optionFilterProp="children"
						filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
						allowClear
						placeholder="Selecione o tipo de pessoa"
						onChange={onTipoPessoaChange}
						showSearch>
						<Select.Option value="Física">Física</Select.Option>
						<Select.Option value="Jurídica">Jurídica</Select.Option>
					</Select>
				</Form.Item>
			</Col>
			<Col xs={24} sm={12}>
				<Form.Item name="cei" label="CEI" hasFeedback >
					<Input placeholder="Digite o CEI (opcional)" style={{ width: '100%' }} />
				</Form.Item>
			</Col>
		</Row>
		{tipo_pessoa != null && tipo_pessoa == "Física" ? (
			<>
				<Row gutter={16}>
					<Col xs={24} sm={12}>
						<Form.Item name="rg" label="RG" hasFeedback >
							<MaskedInput
								mask={[/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/]}
								className="ant-input"
							/>
						</Form.Item>
					</Col>
					<Col xs={24} sm={12}>
						<Form.Item name="cpf" rules={[{ required: true, message: "Campo obrigatório." }]} label="CPF" hasFeedback >
							<MaskedInput
								mask={[/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/]}
								className="ant-input"
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} sm={12}>
						<DatePickerWithMask onKeyUp={onDataNascimentoKeyUp} label="Data de nascimento" name="data_nascimento" disableDateAfter={true} />
					</Col>
					<Col xs={24} sm={12}>
						<Form.Item name="caepf" label="CAEPF" hasFeedback >
							<Input />
						</Form.Item>
					</Col>
				</Row>
			</>
		) : (tipo_pessoa && tipo_pessoa.length > 0 && (
			<>
				<Row gutter={16}>
					<Col xs={24} sm={12}>
						<Form.Item name="cnpj" label="CNPJ" rules={[{ required: true, message: "Campo obrigatório." }]} hasFeedback >
							<MaskedInput
								mask={[/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/]}
								className="ant-input"
								placeholder="00.000.000/0000-00"
							/>
						</Form.Item>
					</Col>
					<Col xs={24} sm={12}>
						<Form.Item name="cno" label="CNO" hasFeedback >
							<Input placeholder="Digite o CNO (opcional)" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} sm={12}>
						<Form.Item name="ie" label="Inscrição Estadual (IE)" hasFeedback >
							<Input placeholder="Digite a IE (opcional)" style={{ width: '100%' }} />
						</Form.Item>
					</Col>
					<Col xs={24} sm={12}>
						<Form.Item name="im" label="Inscrição Municipal (IM)" hasFeedback >
							<Input placeholder="Digite a IM (opcional)" style={{ width: '100%' }} />
						</Form.Item>
					</Col>
				</Row>
			</>
		))}

		<Row gutter={16}>
			<Col sm={8}>
				<Form.Item name="numero_folha" label="Número da Folha" >
					<Input placeholder="Digite o número da folha (opcional)" style={{ width: '100%' }} />
				</Form.Item>
			</Col>
			<Col sm={8}>
				<Form.Item name="nome_responsavel" label="Nome do Responsável" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
					<Input style={{ width: '100%' }} />
				</Form.Item>
			</Col>
			<Col sm={8}>
				<Form.Item name="cargo_responsavel" label="Cargo do Responsável" rules={[{ required: true, message: "Campo obrigatório." }]}>
					<Input style={{ width: '100%' }} />
				</Form.Item>
			</Col>
		</Row>
		<Row gutter={16}>
			<Col sm={8}>
				<Form.Item name="dia_fechamento_periodo" label="Dia de fechamento" rules={[{ required: true, message: "Campo obrigatório." }]}>
					<InputNumber min={1} max={31} style={{ width: '100%' }} />
				</Form.Item>
			</Col>
		</Row>
		<Row gutter={16}>
			<Col xs={24} md={8}>
				<UISwitchField
					bordered
					required
					title="Ativo"
					description="Empresa ativa no sistema."
				>
					<Form.Item name="ativo" valuePropName="checked" rules={[{ required: true, message: "Campo obrigatório." }]} noStyle>
						<Switch />
					</Form.Item>
				</UISwitchField>
			</Col>
			{displayParamsREPP && (
				<>
					{settings && settings.app_empresa && displayAppCompany && (
						<Col xs={24} md={8}>
							<UISwitchField
								bordered
								title="Aplicativo da empresa"
								description="Disponibiliza acesso ao app para esta empresa."
							>
								<Form.Item name="app_empresa" valuePropName="checked" noStyle>
									<Switch />
								</Form.Item>
							</UISwitchField>
						</Col>
					)}
					{settings && settings.app_funcionario && displayAppEmployee && (
						<Col xs={24} md={8}>
							<UISwitchField
								bordered
								title="Aplicativo do funcionário"
								description="Disponibiliza acesso ao app para funcionários."
							>
								<Form.Item name="app_funcionario" valuePropName="checked" noStyle>
									<Switch />
								</Form.Item>
							</UISwitchField>
						</Col>
					)}
				</>
			)}
		</Row>
	</UIFormSection>
);

GeneralInfoFields.propTypes = {
	tipo_pessoa           : PropTypes.string,
	onTipoPessoaChange    : PropTypes.func,
	settings              : PropTypes.object,
	displayParamsREPP     : PropTypes.bool,
	displayAppCompany     : PropTypes.bool,
	displayAppEmployee    : PropTypes.bool,
	nomeInputRef          : PropTypes.func,
	uploadRef             : PropTypes.func,
	onCnpjPrincipalChange : PropTypes.func,
	onDataNascimentoKeyUp : PropTypes.func,
};

export default GeneralInfoFields;
